export default () => {
  return {
    userId: 0,
    abilities: { CanNameWorkspace: false },
    theme: '',
    continuationRoute: null,
    loginRedirect: null,
    startPage: null,
    reports: [],
    errors: [],
    authenticating: false,
    retrievingCurrentUser: false,
    language: null,
    locale: null
  }
}
